import config from './config';
declare global {
	interface Window {
		appKey: string;
		version: string;
		config: any;
	}
}

console.log(`CONFIG`, config);
window.appKey = config.build.appKey;
window.version = config.build.version;
window.config = config;

export default config;
